import * as moment from 'moment';
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';
import {  BIDFORMAT } from './dateOfBirthValidation';

export function getInitialValues(response) {
    // let plusTwo = new Date().setDate(new Date().getDate() + 3)

    // let bidCloseTime = new Date(getTimeState.bidCloseTime).getDate()
    // let createdAt = new Date(getTimeState.createdAt).getDate()

    let requestDeliveryDateSet

    let currentTimeBegin = new Date()
    currentTimeBegin.setHours(8)
    currentTimeBegin.setMinutes(0)

    let beginHours = currentTimeBegin.getHours();
    let beginMinutes = currentTimeBegin.getMinutes()
    let beginCurrentTime = beginHours + ':' + beginMinutes

    let currentTimeEnd = new Date()
    currentTimeEnd.setHours(17)
    currentTimeEnd.setMinutes(0)

    let endHours = currentTimeEnd.getHours();
    let endMinutes = currentTimeEnd.getMinutes()
    let endCurrentTime = endHours + ':' + endMinutes

    let setState = response?.state
    if (response?.state === "California" || response?.state === "Alaska" || !response?.state) {
        setState = "California"
    }
    let nDate;
    let currentTime;
    if (setState === "California" || setState === "California ") {
        // nDate = moment().tz("America/Los_Angeles").format('HH:mm');
        const moment = require('moment-timezone');
        nDate = moment().tz("America/Los_Angeles").format('HH:mm');
        currentTime = nDate
    }
    else if (setState === "Alaska" || setState === "Alaska ") {
        nDate = moment().tz("US/Alaska").format('HH:mm');
        currentTime = nDate
    } else if (setState === "American Samoa") {
        nDate = moment().tz("American/American Samoa").format('HH:mm');
        currentTime = nDate
    } else if (setState === "Washington") {
        nDate = moment().tz("America/Washington").format('HH:mm');
        currentTime = nDate
    } else {
        nDate = new Date().toLocaleString('en-US', {
            timeZone: 'US/' + timeZoneFun(setState)
        });

        let getTime = new Date(nDate)
        let setHours = getTime.getHours()
        let setMinutes = getTime.getMinutes()
        if (setHours.toString().length === 1) {
            setHours = '0' + setHours
        }
        if (setMinutes.toString().length === 1) {
            setMinutes = '0' + setMinutes
        }
        currentTime = setHours + ':' + setMinutes
    }
    requestDeliveryDateSet = moment(new Date().setDate(new Date().getDate() + 3)).format(BIDFORMAT)
    let bidDate = moment(new Date().setDate(new Date().getDate() + 1)).format(BIDFORMAT)
    return {
        appt: beginCurrentTime,
        repostDate: requestDeliveryDateSet,
        requestedStartTime: response?.operationsHourStart? response?.operationsHourStart: beginCurrentTime,
        requestedEndTime: response?.operationsHourEnd? response?.operationsHourEnd: endCurrentTime,
        repostBidCloseTime: bidDate,
        bidTime: currentTime,
    }
}
const VALIDATION_SCHEMA = () => {
}

export { VALIDATION_SCHEMA };